import { useMemo } from "react";
import { createListCollection } from "@ark-ui/react";
import { useField, useForm } from "react-final-form";

import { useMapboxAccountStylesQuery } from "@/lib/mapbox/use-mapbox-account-styles-query";
import Select from "@/components/select/select";
import { required } from "@/features/shared/components/mui-rff-fields/validation-helpers";

interface MapboxStyleSelectorProps {
  name: string;
  label?: string;
  placeholder?: string;
}

const MapboxStyleSelector = ({ name, label, placeholder }: MapboxStyleSelectorProps) => {
  const form = useForm();
  const field = useField(name, {
    validate: required,
  });
  const mapboxQuery = useMapboxAccountStylesQuery();

  const mapboxStyleOptions = useMemo(() => {
    return createListCollection({
      items:
        mapboxQuery.data?.map((option) => ({
          label: option.name,
          value: option.id,
        })) ?? [],
    });
  }, [mapboxQuery.data]);

  if (!mapboxQuery.isSuccess) return null;

  return (
    <Select
      label={label}
      name={field.input.name}
      placeholder={placeholder}
      collection={mapboxStyleOptions}
      value={field.input.value as string}
      onValueChange={(value) => form.change(name, value)}
      error={field.meta.touched ? field.meta.error : undefined}
    />
  );
};

export default MapboxStyleSelector;
